import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
  ScatterController,
} from 'chart.js';
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
  ScatterController,
  TreemapController,
  TreemapElement,
  ChartDataLabels
);

(ChartJS.defaults.plugins as { datalabels?: { display?: boolean } }).datalabels = {
  ...((ChartJS.defaults.plugins as { datalabels?: object }).datalabels ?? {}),
  display: false,
};
